import { FC } from "react";
import { Text } from "@chakra-ui/react";

interface Props {
  children: React.ReactNode;
}

export const CardTitle: FC<Props> = ({ children }) => {
  return (
    <Text fontWeight="bold" variant="th-body1">
      {children}
    </Text>
  );
};
